<template>
  <div class="download">
    <isWeixinMark :isWeixin="isWeixin"
                  @onCancelMark="isWeixin=false" />
    <div class="downloadImage"
         @click="onDownload">
      <img src="../assets/images/xiazai_duan.png" />
    </div>
  </div>
</template>

<script>
import isWeixinMark from '../components/isWeixinMark'
import { getList } from '../api/wap'
export default {
  name: 'down',
  components: {
    isWeixinMark
  },
  data () {
    return {
      downloadLink: '',
      isWeixin: false
    }
  },
  created () {
    this.onLoadData()
  },
  methods: {
    onLoadData () {
      getList({ type: 1 })
        .then(res => {
          this.downloadLink = res.result.download_url.android
        })
    },
    onDownload () {
      const u = window.navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIos) {
        location.href = 'https://apps.apple.com/cn/app/%E8%81%94%E5%90%A7/id1404140841'
      }
      if (isAndroid) {
        this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1
        if (!this.isWeixin) {
          location.href = this.downloadLink
        }
      }
    }
    // scroll(e) {
    //   console.log(e);
    // }
  }
}
</script>

<style scoped>
.downloadImage {
  text-align: center;
  padding: 0.2rem 0 0.2rem 0;
  display: flex;
  background: #fff;
  align-items: center;
  justify-content: center;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
</style>
